import Client from "../AxiosClient";
const resource = "/private/dropdowns";

export default {
  async get(type) {
    try {
      const response = await Client.get(`${resource}/${type}`);
      return response.data.data;
    } catch (error) {
      return { error: error };
    }
  },
  type: {
    YEARS: `years`,
    EMPLOYEES: `employees`,
    DEPARTMENTS: `departments`,
    ACCOUNTS: `accounts`,
    TOPICS: `topics`,
  },
  async getEmployeeByDepartment() {
    try {
      const response = await Client.get(`${resource}/employeebydepartment`);
      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },
  async getiOfficeEmployeeByDepartment() {
    try {
      const response = await Client.get(
        `${resource}/ioffice-employee-by-department`
      );
      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async getItemsTree(catCode) {
    try {
      const response = await Client.get(
        `${resource}/items?cat_code=${catCode}`
      );
      return response.data.data;
    } catch (error) {
      return { error: error };
    }
  },

  async getDatabaseFinance_qt() {
    try {
      const response = await Client.get(`${resource}/databasefinance_qt`);
      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },
  async getDatabaseFinance_ts() {
    try {
      const response = await Client.get(`${resource}/databasefinance_ts`);
      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },
};
